import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { BrowserRouter } from "react-router-dom";

// i18n — doit être importé avant le rendu pour initialiser les traductions
import "./i18n/i18n";


ReactDOM.render(
  <BrowserRouter>
 <App/>
  </BrowserRouter>,
  document.getElementById("root")
);
